export const jsQuestions = [
  {
    title: "۱. Hoisting چیه؟",
    description: "",
  },
  {
    title: "۲. کلاژور چیه؟",
    description: "",
  },
  {
    title: "۳.کلمه کلیدی this چطوری کار میکنه؟",
    description: "",
  },
  {
    title:
      "۴. چند تا تابع روی آرایه اسم ببر که سورس اصلی آرایه داده شده رو عوض میکنن؟",
    description: "",
  },
  {
    title: "۵. Currying چیه؟",
    description: "",
  },
  {
    title: "۶. کدهای async توی موتور جاواسکریپت چطوری کار میکنن؟",
    description: "",
  },
  {
    title: "۷. فرق async و sync چیه؟",
    description: "",
  },
  {
    title: "۸. تفاوت mutation و immutation چیه؟ یه مثال ؟",
    description: "",
  },
  {
    title:
      "۹. نوع داده های اصلی یا primitive کدوما هستن و چه فرقی با نوع داده های رفرنسی دارن؟",
    description: "",
  },
  {
    title: "۱۰. پروتو تایپ‌ها توی جاواسکریپت چی هستن؟ و چیکار میکنن؟",
    description: "",
  },
  {
    title: "۱۱. Memorization چیه و چطوری کار می‌کنه؟",
    description: "",
  },
  {
    title: "۱۲. پرامیس ها چطوری کار میکنن؟",
    description: "",
  },
  {
    title: "۱۳. یه مثال و کاربرد برای متدهای روی پرامیس مثل all و race بزن؟",
    description: "",
  },
  {
    title: "۱۴. فرق let, var, const چیه؟",
    description: "",
  },
  {
    title: "۱۵. تشابه و تفاوت های متدهای bind و call و apply چیا هستن؟",
    description: "",
  },
  {
    title: "۱۶. کدنویسی DRY چیه؟ فرقش با WET چیه؟",
    description: "",
  },
  {
    title: "۱۷. توی HTML5 چه امکاناتی روی جاواسکریپت داریم؟",
    description: "",
  },
  {
    title:
      "۱۸. Capturing و bubbling روی ایونت ها رو توضیح میدی چطوری کار میکنن و چه ماهیتی دارن؟",
    description: "",
  },
  {
    title: "۱۹. کاربرد garbage collector چیه؟",
    description: "",
  },
  {
    title: "۲۰. فرق map و weakmap چیه؟",
    description: "",
  },
  {
    title: "۲۱. وقتی از یه کلاسی new می‌کنیم اون پشت چی میشه؟",
    description: "",
  },
  {
    title: "۲۲. توابع pure چه توابعی هستن؟",
    description: "",
  },
  {
    title: "۲۳. برنامه نویسی تابعی چیه و چطوری کار می‌کنه؟",
    description: "",
  },
  {
    title:
      "۲۴. توی es6 و به بالاتر از امکاناتی که اضافه شده ۴ مورد رو نام ببر؟",
    description: "",
  },
  {
    title: "۲۵. فرق es و js چیه؟",
    description: "",
  },
  {
    title: "۲۶. توابع جنریتور چی هستن؟ چطوری کار میکنن؟ و یه مثال ؟",
    description: "",
  },
  {
    title: "۲۷. سرویس ورکر چطوری کار می‌کنه؟",
    description: "",
  },
]
export const reactQuestions = [
  {
    title:
      "۱. فرق کامپوننت و pure component چیه؟ چرا از pure component استفاده کنیم؟",
    description: "",
  },
  {
    title:
      "۲. اگه یه کاری رو بخواییم با هوک انجام بدیم ولی بخواییم موقعی که مثلا‌ یه ایونت کلیک رخ داد انجام بشه، چطوری انجامش میدیم؟",
    description: "",
  },
  {
    title:
      "۳. یه هوک بخواییم درست کنیم که فقط موقع اپدیت اجرا بشه و موقع مانت اجرا نشه چیکار میکنیم؟",
    description: "",
  },
  {
    title: "۴. اگه به useEffect هیچ پارامتر دومی ندیم چی میشه؟",
    description: "",
  },
  {
    title: "۵. چطوری میشه فقط موقع اپدیت شدن یه متغیر یه تابع رو اجرا کرد؟",
    description: "",
  },
  {
    title: "۶. برای هوک های useMemo و useCallback یه مثال بزن؟",
    description: "",
  },
  {
    title:
      "۷. موقع اجرای یه کامپوننت به ترتیب چه فازهایی طی میشه و توی هر فاز چه توابعی فراخوانی میشه؟",
    description: "",
  },
  {
    title: "۸. چطوری میشه code-split انجام داد؟",
    description: "",
  },
  {
    title: "۹. برای پرفورمنس چیکارا میشه کرد؟ (پرفورمنس توی رندر؟",
    description: "",
  },
  {
    title: "۱۰. با چه روش هایی میشه به ری‌اکت استایل داد، تو با چی میزنی؟ چرا؟",
    description: "",
  },
  {
    title: "۱۱. برای روتر با کدوم لایبرری کار میکنی چرا؟",
    description: "",
  },
  {
    title:
      "۱۲. بحث سرور ساید رندرینگ چه اطلاعاتی داری و ترجیح میدی با چی کار کنی؟",
    description: "",
  },
  {
    title:
      "۱۳. برای مدیریت استیت با چی کار میکنی ریداکس، mobx یا ریکویل؟ یه مقایسه بینشون انجام بده؟",
    description: "",
  },
  {
    title: "۱۴. روی ریداکس چطوری میتونی پرفورمنس برنامه رو ببری بالاتر؟",
    description: "",
  },
  {
    title: "۱۵. برای ساید افکت ها روی ریداکس چیکار میکنی؟",
    description: "",
  },
  {
    title: "۱۶. برای تست ری‌اکت با چی کار میکنی و چرا؟",
    description: "",
  },
]
